/*!
 * ADYJO Video Protect
 * Hides browser download affordances where possible.
 */
(function (window, document) {
  'use strict';

  function harden(video) {
    try {
      video.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
      video.setAttribute('disablePictureInPicture', '');
      video.setAttribute('oncontextmenu', 'return false;');
      video.setAttribute('playsinline', '');
      video.addEventListener('contextmenu', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }, true);
    } catch (err) {}
  }

  function init() {
    var videos = document.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      harden(videos[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, false);
  } else {
    init();
  }
})(window, document);
